<template>
  <div
    v-if="licenseId !== ''"
    style="display: flex; flex-direction: column; align-items: center; gap: 12px"
  >
    <div
      class="caption px-4 pt-2 text-justify"
      style="
            color: rgba(255, 255, 255, 0.5);
            max-width: 960px;
            margin: 0 auto;
          "
    >
      <span v-html="licenseText"></span>
    </div>

    <div
      style="width: 50px;"
      :id="`anj-${licenseId}`"
      :data-anj-seal-id="licenseId"
      data-anj-image-size="128"
      data-anj-image-type="basic-small"
    ></div>
    <component
      :is="'script'"
      :src="`https://${licenseId}.snippet.anjouangaming.org/anj-seal.js`"
      async
    /></div
></template>

<script>
export default {
  data: () => ({
    licenseId: "",
  }),

  created() {
    const mapDomainToLicenseId = {
      a3bet: "4f8b0464-6613-4ba1-8f75-cdaf8dc0d969",
      aki: "c8fca25b-1ea2-41c7-9b7b-872c50ed0275",
      amabet: "0bc291e8-6984-489f-9964-6d7e2561edf3",
      jogodeourobet: "d1b49a60-2003-44e5-9dc9-b5375f0821a2",
      pagamaissports: "62dfec9b-3b79-4b30-ae8b-8fe597724762",
      pingolbet: "187cff4b-5745-4554-81c8-80027224252c",
      sullbet: "5637c61a-40bd-48d5-89f7-901b1a1c1c89",
    };

    const licenseId = mapDomainToLicenseId[this.$domain()];
    this.licenseId = licenseId;

    setTimeout(() => {
      const fun = "anj_" + licenseId.replaceAll("-", "_");
      window[fun].init();
    }, 500);
  },

  computed: {
    licenseText() {
      if (!this.$store.state.operators) {
        return "";
      }

      const operatorName = this.$store.state.operators.operator_name;
      const ownedBy = "Titans Games N.V";
      const registrationNumber = 158870;
      const fullLegalAddress =
        "Kaya W.f.G (Jombi), 24, Unit A, Willemstad, Curacao";

      return `${operatorName} is owned and operated by ${ownedBy}. registered in Curacao under the number ${registrationNumber}. Registered address: ${fullLegalAddress}.
        Contact us: contact@sga.bet. ${operatorName} is licensed and regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros and
        operates under License No. ALSI-192407038-F12. ${operatorName} has passed all regulatory compliance and is legally authorized to conduct gaming operations
        for any and all games of chance and wagering.`;
    },
  },
};
</script>
